<template>
    <main id="register-page" class="max-width-container">
        <h1>Register</h1>
        <RegisterForm :errors="errors" @submit-form="submitForm" />
    </main>
</template>

<script>
import { useUserStore } from "../../stores/userStore";
import BaseFormWrapper from "js/components/base/BaseFormWrapper.js";
import RegisterForm from "js/components/forms/RegisterForm";

export default {
    name: "Register",
    components: {
        RegisterForm,
    },
    extends: BaseFormWrapper,
    data() {
        return {
            store: null,
        };
    },
    mounted() {
        this.store = useUserStore();
    },
    methods: {
        submitForm(data) {
            this.store
                .create("api/register", data)
                .then((result) => {
                    if (result) {
                        this.store.justRegistered = true;
                        this.$router.replace("/login");
                    }
                })
                .catch(this.handleResponseErrors);
        },
    },
};
</script>
